export const service = [
  { id: "0", price: "500", name: "Periodic services" },
  { id: "1", price: "800", name: "Denting and painting" },
  { id: "2", price: "1500", name: "Batteries" },
  { id: "3", price: "1200", name: "Car services and cleaning" },
  { id: "4", price: "2000", name: "AC service and repair" },
  { id: "5", price: "3500", name: "Tyres and wheel care" },
  { id: "6", price: "3000", name: "Clutch and fitments" },
  { id: "7", price: "1000", name: "Windshields and light" },
  { id: "8", price: "1100", name: "Custom service" },
];
